<button [disabled]="isDownloading" nz-button nzShape="circle">
  <mat-icon (click)="downloadItem()" color="primary">download</mat-icon>
</button>
